import { useEffect, useState } from "react";
import { contactUsFromLandingPage, getCountryData } from "src/pages/api/user";
import Button from "@/admin/atoms/Button";
import CrestAgileInput from "@/admin/atoms/CrestAgileInput";
import CheckBox from "@/sharedComponents/atoms/CheckBox";
import Modal from "@/sharedComponents/molecules/Modal";
import LandingPageNavArea from "../LandingPageComponents/LandingPageNavArea";
import CreateAccountSuccessModal from "../ContactUsBackground/CreateAccountSuccessModal";
import AdminOnboardingBottomArea from "../AdminOnboardingBottomArea";
import styles from "./ContactUsAdminBackground.module.css";

type ContactUsAdminBackgroundProps = {
  // Add any props if needed in the future
  modalIsOpen: (arg: boolean) => void;
};

function ContactUsAdminBackground(
  props: ContactUsAdminBackgroundProps
): JSX.Element {
  const { modalIsOpen } = props;
  const [isMobile, setIsMobile] = useState(false);
  const [email, setEmail] = useState("");
  const [emailIsEmpty, setEmailIsEmpty] = useState(false);
  const [emailError, setEmailError] = useState("");

  const [location, setLocation] = useState("");
  const [locationIsEmpty, setLocationIsEmpty] = useState(false);
  const [locationError, setLocationError] = useState("");

  const [phone, setPhone] = useState("");
  const [phoneIsEmpty, setPhoneIsEmpty] = useState(false);
  const [phoneError, setPhoneError] = useState("");

  const [reasons, setReasons] = useState("");
  const [reasonsIsEmpty, setReasonsIsEmpty] = useState(false);
  const [reasonsError, setReasonsError] = useState("");

  const [checkBoxValue, setCheckBoxValue] = useState(false);
  const [checkBoxValue2, setCheckBoxValue2] = useState(false);
  const [reasonsDetail, setReasonsDetail] = useState("");

  function handleWindowSizeChange() {
    setIsMobile(window.innerWidth <= 768);
  }

  const [countryCode, setCountryCode] = useState(44);
  const [countryData, setCountryData] = useState<any>([]);
  const [countryReady, setCountryReady] = useState(false);
  const [locationOption, setLocationOption] = useState<string[]>([]);
  const [disableBtn, setDisableBtn] = useState(true);
  const [btnText, setBtnText] = useState("Submit");
  const [contactSubmitted, setContactSubmitted] = useState(false);
  const [contactViaPhone, setContactViaPhone] = useState(false);
  const [contactViaEmail, setContactViaEmail] = useState(false);

  const reasonsOption = [
    "General Inquiry",
    "Technical Support",
    "Billing & Payment Issues",
    "Account Management",
    "Course Creation Assistance",
    "Feature Request",
    "Partnership Opportunities",
    "Sales Inquiry",
    "Starter Plan",
    "Demo Request",
    "Feedback & Suggestions",
  ];

  const loadCountryData = () => {
    const lOption: string[] = [];
    getCountryData().then((countryData2) => {
      console.log("countryData2", countryData2);
      setCountryCode(Number(countryData2?.data[0]?.phone_code));
      setLocation(countryData2?.data[0]?.country);
      setCountryData(countryData2);

      countryData2.data.forEach((cData: any) => {
        lOption.push(cData?.country);
      });
      setLocationOption(lOption);
      setCountryReady(true);
    });
  };

  useEffect(() => {
    if (contactSubmitted) {
      modalIsOpen(true);
    } else {
      modalIsOpen(false);
    }
  }, [contactSubmitted]);

  useEffect(() => {
    if (countryReady) {
      const selectedCountry: any = countryData?.data?.filter(
        (cData: any) => cData.country === location
      );
      setCountryCode(Number(selectedCountry[0]?.phone_code));
    }
  }, [location]);

  useEffect(() => {
    if (window.Tawk_API) {
      window.Tawk_API.hideWidget();
    }
    loadCountryData();
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  console.log(
    isMobile,
    setEmailError,
    setEmailIsEmpty,
    setLocationError,
    setLocationIsEmpty,
    setReasonsError,
    setReasonsIsEmpty,
    setPhoneError,
    setPhoneIsEmpty,
    setCheckBoxValue,
    setCheckBoxValue2,
    loadCountryData,
    countryData,
    countryReady
  );

  const handleSubmit = () => {
    setDisableBtn(true);
    setBtnText("Processing...");
    contactUsFromLandingPage(
      email,
      location,
      `${countryCode} ${phone}`,
      reasons,
      reasonsDetail,
      contactViaPhone,
      contactViaEmail
    ).then((contactResponse) => {
      console.log("contactResponse", contactResponse);
      setDisableBtn(false);
      setBtnText("Submit");
      if (contactResponse.data.status === "success") {
        setContactSubmitted(true);
        console.log("success");
      }
    });
  };

  const checkInputFilds = () => {
    setDisableBtn(
      !(email !== "" && location !== "" && phone !== "" && reasons !== "")
    );
  };

  const handleInputChanges = () => {
    checkInputFilds();
  };

  const updateCheckedValue = (checkDetail: any) => {
    console.log("checking...", checkDetail[0]);
    setContactViaEmail(checkDetail[0] === "emailCheck");
    setContactViaPhone(checkDetail[0] === "phoneCheck");
  };

  if (countryReady) {
    return (
      <div
        className={styles.frame}
        onKeyDown={(e) => {
          if (
            (e.code === "Enter" || e.charCode === 13) &&
            disableBtn === false
          ) {
            const focusedElement = document.activeElement;
            console.log("TESTING KEEEEEY", focusedElement?.id);
            document.getElementById("emailValue")?.focus();

            //   if(focusedElement?.id.includes("industryValuedropdownValue")){
            //       document.getElementById("emailValue")?.focus();
            //   }
            // console.log()

            handleSubmit();
          } else {
            console.log("");
          }
        }}
        tabIndex={0}
        role="button"
        onKeyUp={() => {}}
      >
        {contactSubmitted && (
          <div>
            {/*
            <CreateAccountSuccessModal
              closeModal={setContactSubmitted}
              variant={"contact"}
              userEmail={""}
              userPassword={""}
              companyName={""}
            />
            */}
            <Modal isOpen onClose={() => {}}>
              <CreateAccountSuccessModal
                closeModal={setContactSubmitted}
                variant={"contact"}
                userEmail={""}
                userPassword={""}
                companyName={""}
              />
            </Modal>
          </div>
        )}
        <LandingPageNavArea showDesktopMenu />
        <div className="w-full h-[212px] phone:h-[143px] bg-[#4856DD] flex flex-col justify-center items-center">
          <div className="w-full text-center text-[30px] phone:text-[20px] text-white font-bold">
            Contact Us
          </div>
          <div className="w-full text-center phone:w-[90%] text-[18px] phone:text-[14px] text-white">
            Have questions or need support? We’re here to help! Reach out to us
            anytime.
          </div>
        </div>

        <div className={styles.middlePane}>
          <div className={styles.contentArea}>
            <div className="w-full font-medium text-center text-3xl phone:text-[24px] flex justify-center text-[#262626]">
              We’d Love to Hear From You!
            </div>
            <div className="text-center">
              Have questions about MyEdVault? Need support or want to explore
              how our platform can help your organization? Our team is here to
              assist you.
            </div>
            <div className="w-full flex flex-col gap-y-6 mt-10">
              <CrestAgileInput
                variant="email"
                height="medium"
                width="full"
                getInputedValue={setEmail}
                value={email}
                label="Email Address"
                required
                isEmpty={emailIsEmpty}
                actionCallBack={handleInputChanges}
                placeholder="e.g Example@gmail.com"
                id="emailValue"
                errMsg={emailError}
              />

              <div className="w-full flex gap-x-4 phone:gap-y-6 phone:flex-col">
                <div className="w-1/2 phone:w-full">
                  <CrestAgileInput
                    variant="select"
                    height="medium"
                    width="full"
                    getInputedValue={setLocation}
                    value={location}
                    label="Location"
                    required
                    isEmpty={locationIsEmpty}
                    selectOptions={locationOption}
                    actionCallBack={handleInputChanges}
                    placeholder="e.g Nigeria"
                    id="locationValue"
                    errMsg={locationError}
                    showSearch
                  />
                </div>
                <div className="w-1/2 phone:w-full">
                  <CrestAgileInput
                    variant="phone"
                    height="medium"
                    width="full"
                    getInputedValue={setPhone}
                    value={phone}
                    label="Phone Number"
                    required
                    isEmpty={phoneIsEmpty}
                    actionCallBack={handleInputChanges}
                    placeholder=".................."
                    id="phoneValue"
                    countryCode={countryCode}
                    errMsg={phoneError}
                  />
                </div>
              </div>

              <div>
                <CrestAgileInput
                  variant="select"
                  height="medium"
                  width="full"
                  getInputedValue={setReasons}
                  value={reasons}
                  label="Reasons for Contacting Us"
                  required
                  isEmpty={reasonsIsEmpty}
                  selectOptions={reasonsOption}
                  actionCallBack={handleInputChanges}
                  placeholder="e.g Partnership"
                  id="reasonValue"
                  errMsg={reasonsError}
                  showSearch
                />
              </div>

              <div className="w-full mt-2">
                <CrestAgileInput
                  variant="textarea"
                  height="medium"
                  width="full"
                  getInputedValue={setReasonsDetail}
                  value={reasonsDetail}
                  label="What to discuss (Optional)"
                  actionCallBack={handleInputChanges}
                  placeholder="Type here"
                  id="reasonDetailValue"
                  showSearch
                  required={false}
                />
              </div>

              {/* <div className="border border-[#979797] border-dashed mt-5" /> */}

              <div className="text-[16px] text-[#3c3c3c]">
                Preferred Contact Method:
              </div>

              <div className="w-full flex">
                <div className="flex w-1/2">
                  <CheckBox
                    id={"phoneCheck"}
                    state="default"
                    checked={checkBoxValue}
                    getCheckedElement={updateCheckedValue}
                  />
                  <span className="ml-2">Phone</span>
                </div>
                <div className="flex w-1/2">
                  <CheckBox
                    id={"emailCheck"}
                    state="default"
                    checked={checkBoxValue2}
                    getCheckedElement={updateCheckedValue}
                  />
                  <span className="ml-2">Email</span>
                </div>
              </div>

              <div className="w-full flex flex-col mt-10">
                <Button
                  variant="landing-primary2"
                  disabled={disableBtn}
                  onClick={() => {
                    handleSubmit();
                  }}
                  id="submit-for-schedule"
                >
                  <p className="w-full py-6">{btnText}</p>
                </Button>
              </div>
            </div>
          </div>
        </div>

        <AdminOnboardingBottomArea />
      </div>
    );
  }
  return <div />;
}

export default ContactUsAdminBackground;
